import { AuthService } from 'services';

export const authHeader = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  if (user && user.token) {
    const sessionExpireAt = localStorage.getItem('sessionExpireAt') || 0;

    if (sessionExpireAt < new Date().getTime()) {
      AuthService.signOut();
      window.location.reload();
    }

    return { Authorization: 'Bearer ' + user.token };
  } else {
    return {};
  }
};
